import { AppThunk } from 'store/types';
import {
  setVendorPayoffsDataAction,
  setSearchPayoffsSettingsAction,
  setVendorPayoffsErrorAction,
  setVendorPayoffsFetchStatusAction,
} from './reducer';
import { createFetchInProgress, createFetchedSuccess, createFetchedWithError } from 'types/rest/IFetchStatus';
import { eTitleSearchStatus } from 'types/order/title/eTitleSearchStatus';
import { getPayoffsAsync } from '../../../API/vendorDashboard/VendorAPI';
import { Logger } from '../../../ui-toolkit/logging/LoggerService';

export const getVendorPayoffsData =
  (statuses: eTitleSearchStatus[], pageSize: number, page: number, fileNumber?: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(
        setSearchPayoffsSettingsAction({
          page,
          pageSize,
          statuses,
        })
      );
      dispatch(setVendorPayoffsErrorAction(undefined));
      dispatch(setVendorPayoffsFetchStatusAction(createFetchInProgress()));
      const response = await getPayoffsAsync(statuses, pageSize, page, fileNumber);
      dispatch(setVendorPayoffsDataAction(response.payoffRequests));
      dispatch(setVendorPayoffsFetchStatusAction(createFetchedSuccess()));
      if (response.setting.pageSize !== pageSize || response.setting.page !== page) {
        dispatch(setSearchPayoffsSettingsAction(response.setting));
        Logger.error(`Error get Payoffs request`, {
          userPage: page,
          responsePage: response.setting.page,
          userPageSize: pageSize,
          responsePageSize: response.setting.pageSize,
        });
      }
    } catch (e: any) {
      dispatch(setVendorPayoffsFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorPayoffsErrorAction(e.message));
    }
  };
